import { styled, Box } from '@mui/material'

export const SetHospital = styled(Box)({
  ".app-header": {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    display: 'flex'
  },
  ".nav": {
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    padding: "0",
    paddingLeft: "20px",
    paddingRight: "20px",
    backgroundColor: "#5382c2",
    color: "white",
    fontWeight: "700",
    paddingTop: "5px",
    paddingBottom: '5px'
  },
  ".nav-name": {
    display: "flex",
  },
  ".btn": {
    boxSizing: "border-box",
    border: "0",
    borderRadius: "20px",
    color: "#313131",
    padding: "0.7em 1em",
    background: "#fff",
    display: "flex",
    transition: "0.2s background",
    fontWeight: "bold",
    gap: "2px",
    justifyContent: "right"
  },
  ".btn .arrow-wrapper": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "6px",
  },
  ".btn .arrow": {
    marginTop: "1px",
    width: "10px",
    background: "#fff",
    height: "2px",
    position: "relative",
    transition: "0.2s",
  },
  ".btn .arrow::before": {
    content: '""',
    boxSizing: "border-box",
    position: "absolute",
    border: "solid #313131",
    borderWidth: "2px 0 0 2px",
    display: "inline-block",
    top: "-3px",
    left: "3px",
    transition: "0.2s",
    padding: "3px",
    transform: "rotate(-45deg)",
  },
  ".btn:hover": {
    backgroundColor: "#b6e4fe",
  },
  ".btn:hover .arrow": {
    background: "#313131",
  },
  ".btn:hover .arrow:before": {
    left: "0",
  },
  ".card-header": {
    display: 'flex',
    marginTop: '-20px',
    width: '800px',
    marginBottom: '40px',
    marginLeft: '40px',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  ".cards": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "15px",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  ".cards .card": {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    height: "220px",
    width: "820px",
    borderRadius: "25px",
    color: "white",
    cursor: "pointer",
    transition: "400ms",
  },
  ".cards .card .tip": {
    fontSize: "1.5em",
    fontWeight: "1000",
    color: "#5382c2",
    marginLeft: "45px",
    marginTop: "28px",
    marginBottom: '10px'
  },
  ".cards .card .second-text": {
    marginTop: "0",
    fontSize: "16px",
    fontWeight: "500",
    color: "#313131",
    marginLeft: "45px",
    marginRight: "130px",
  },
  ".cards .main": {
    backgroundColor: "#fff",
    minHeight: "max-content"
  },
  ".card-hide": {
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    minheight: "200px",
    width: "780px",
    borderRadius: "0px 0px 25px 25px",
    color: "black",
    cursor: "pointer",
    transition: "400ms",
    padding: "20px",
    lineHeight: "30px",
    margin: "-18px 0px 10px 0px"
  },
  ".btnHpt": {
    boxSizing: "border-box",
    border: "0",
    borderRadius: "20px",
    color: "#313131",
    padding: "0.7em 1em",
    background: "#b6e4fe",
    display: "flex",
    transition: "0.2s background",
    fontWeight: "bold",
    marginLeft: "80%",
    marginTop: '-20px'
  },
  ".btnHpt:hover": {
    backgroundColor: "gray",
  },
  ".logo": {
    height: "80px",
    width: "90px",
    marginLeft: "81%",
    marginTop: "-120px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    marginBottom: '40px'
  },
  '.load': {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  '.btnIcon': {
    height: '15px',
    width: '15px',
    color: '#fff',
    marginLeft: '5px',
    transform: 'scaleY(-1)'
  },
  '.date': {
    margin: '35px'
  },
  '.btnIcon:hover': {
    height: '15px',
    width: '15px',
    color: '#fff',
    marginLeft: '5px',
  }
});
